import React, { useContext, useEffect, useState } from 'react'
import { getRequest } from '../../../request/request'
import { errors } from '../../../function/errors'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { UlList } from './css/MapsStyle'
import { Button, Empty, Spin } from 'antd'
import { Title } from '../../../style/style'
import { AppContext } from '../../../App'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import { DownloadOutlined, FullscreenOutlined, MinusOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons'
import { ContextType } from '../../../type/type'
import FileSaver from 'file-saver'

interface SubregionItem {
  id: number;
  subregion_name: string;
  maps: SubregionMaps[];
}

interface SubregionMaps {
  id: number;
  title: string;
  map_image: string
}

const Maps = () => {
  const { t } = useTranslation()
  const { state } = useContext<ContextType>(AppContext)
  const { type } = useParams()
  const [data, setData] = useState<any>(null)
  const [srcMapImage, setSrcMapImage] = useState<any>(null)
  const [srcMapTitle, setSrcMapTitle] = useState<any>('')
  const [visible, setVisible] = useState<boolean>(true)
  const [titleName, setTitleName] = useState<string>('')

  useEffect(() => {
    setVisible(true)
    setData(null)
    setTitleName('')
    getRequest(`/maps/subregion/with_maps/?region_id=${type}&page_size=50`)
      .then((res) => {
        setData(res?.data.results)
      })
      .catch((err) => errors(err))

    getRequest(`/maps/region/${type}/`)
      .then((res) => {
        setTitleName(res?.data?.region_name)
      })
      .catch((err) => errors(err))
  }, [state.lang, type])

  const download = () => {
    const extension = srcMapImage.split('.')
    const name = srcMapImage.split('/')

    FileSaver.saveAs(srcMapImage, `${name[name.length - 1].split('.')[0]}.${extension[extension.length - 1]}`)
  }

  return (
    <>
      <Title className="title">{`${t('t1')}: ${titleName}`}</Title>
      <Spin spinning={!data}>
        {data &&
          visible &&
          (data.length !== 0 ? (
            <UlList>
              {data.map(({ id, subregion_name, maps }: SubregionItem) => (
                <li
                  style={{ marginBottom: 10 }}
                  key={id}
              >
                <div key={id} style={{ marginBottom: 10 }}>
                  {subregion_name}
                </div>
                <UlList>
                  {maps.map(({ id, title, map_image }: SubregionMaps) => (
                    <li
                      style={{ marginBottom: 10 }}
                      key={id}
                      onClick={() => {
                        setSrcMapImage(map_image)
                        setSrcMapTitle(title)
                        setVisible(false)
                      }}
                    >
                      <div className="cursor-pointer hover-underline" key={id} style={{ marginBottom: 10 }}>
                        {title}
                      </div>
                    </li>
                  ))}
                </UlList>
              </li>
              ))}

            </UlList>
          ) : (
            <Empty />
          ))}
      </Spin>

      {!visible && (
        <>
          <h3>{srcMapTitle}</h3>
          <br />
          <p>
            <Button type="primary" onClick={() => setVisible((e) => !e)}>
              {t('h14')}
            </Button>
          </p>
          <br />
          <TransformWrapper initialScale={1} minScale={0.6} maxScale={20} centerOnInit={true}>
            {({ zoomIn, zoomOut, resetTransform }) => (
              <>
                <div className="tools mb-10">
                  <Button onClick={download}>
                    <DownloadOutlined />
                  </Button>
                  <Button onClick={() => resetTransform()}>
                    <ReloadOutlined />
                  </Button>
                  <Button onClick={() => zoomOut()}>
                    <MinusOutlined />
                  </Button>
                  <Button onClick={() => zoomIn()}>
                    <PlusOutlined />
                  </Button>

                  <Button style={{ float: 'right' }}>
                    <a href={srcMapImage} target="_blank" rel="noreferrer">
                      <FullscreenOutlined />
                    </a>
                  </Button>
                </div>

                <TransformComponent>
                  <img src={srcMapImage} alt="" width="100%" />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </>
      )}
    </>
  )
}

export default Maps
